/**
 * The purpose of this Enum is avoiding string literals routes
 */
export enum RoutePaths {
    empty = '',
    wildCard = '**',
    login = 'login',
    changePassword = 'change-password',
    updatePassword = 'update-password',
    registration = 'register',
    cookiesPage = 'cookies-policy',
    policyPage = 'privacy-policies',
    home = 'home',
    contentManag = 'my-content',
    contentEditor = 'content-maintenance',
    managements = 'my-managements',
    contentPowerBI = 'content-powerbi',
}
